<div
  class="containerPhoto"
  #photoContainer
  [ngStyle]="{
    'aspect-ratio': ratio | async
  }"
  >
  <div class="box" (click)="clickPoint($event)">
    @if (selectedPoint) {
      <div
        class="ball"
        #ball
      [ngStyle]="{
        'margin-top.px': this.yInPx,
        'margin-left.px': this.xInPx,
        transition: transition
      }"
      ></div>
    }
    @if (!selectedPoint) {
      <div
        class="window"
      [ngStyle]="{
        'width.px': widthText,
        'margin-top.px': this.yText,
        'margin-left.px': this.xText,
        'font-size.px': this.sizeText
      }"
        >
        KLIKNIJ ABY USTAWIĆ PUNKT CENTRALNY
      </div>
    }
    @if (url) {
      <img
        [src]="url"
        alt="photo"
        #imageContainer
        (load)="recalculate$.next()"
        />
    }
  </div>
</div>
